// Utility function to capitalize the first letter of a string
export function cap(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
